import * as yup from 'yup'

const REQUIRED_FIELD_MSG = 'This field is required.'
export enum FIELDS {
  CODE = 'code',
}

export const schema = yup
  .object({
    [FIELDS.CODE]: yup
      .string()
      .matches(/^\d{6}$/, 'The code must be exactly 6 digits long')
      .required(REQUIRED_FIELD_MSG),
  })
  .required()
